import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { usePageTitle } from "@/lib/usePageTitle";

export default function Account() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  usePageTitle("Account settings — Olivia Does");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password.length < 6) { setError("New password must be at least 6 characters."); return; }
    if (form.new_password !== form.confirm) { setError("New passwords don't match."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", {
        current_password: form.current_password, new_password: form.new_password,
      });
      toast.success(data.message || "Password updated.");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="account-page" className="max-w-xl mx-auto px-6 py-16">
      <p className="od-eyebrow">Account</p>
      <h1 className="font-display text-4xl mt-1">Your account</h1>
      <div className="od-card p-6 mt-8">
        <p className="text-sm text-[#78716C]">Signed in as</p>
        <p className="font-medium">{user?.name} · <span className="capitalize">{user?.role}</span></p>
        <p className="text-sm text-[#78716C]">{user?.email}</p>
      </div>

      <div className="od-card p-8 mt-6">
        <h2 className="font-display text-2xl">Change password</h2>
        <form onSubmit={submit} className="mt-6 space-y-4">
          {error && <div data-testid="change-pw-error" className="rounded-lg border border-[#993333]/30 bg-[#993333]/10 text-[#993333] text-sm px-4 py-3">{error}</div>}
          <div>
            <Label className="text-xs uppercase tracking-widest text-[#78716C]">Current password</Label>
            <Input data-testid="current-password" type="password" required value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="mt-2 rounded-xl border-[#E2DBD6]" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-[#78716C]">New password</Label>
            <Input data-testid="new-password" type="password" required value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="mt-2 rounded-xl border-[#E2DBD6]" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-[#78716C]">Confirm new password</Label>
            <Input data-testid="confirm-password" type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="mt-2 rounded-xl border-[#E2DBD6]" />
          </div>
          <Button data-testid="change-pw-submit" disabled={busy} type="submit" className="w-full rounded-full bg-[#2A2624] hover:bg-[#1E1A18] py-6">
            {busy ? "Updating…" : "Update password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
